export class UserData { 

    

    private _storageNames = {
        sede:'_sede',
        lastUserLogged:'_last_user_logged',
        showSedeField: '_show_sede_field',
        user:'_user',
        userToken:'_user_token',
        clientPictures: '_client_pictures'
    };

    private _values = {
        sede:'HMO',
        lastUserLogged: '',
        showSedeField: false,
        user: null,
        userToken: null,
        commonConfig: null,
        clientPictures: []
    };



    get sede(): string { return this._values.sede; }
    set sede(value: string) {
        if (!value || value == "") {
            this._values.sede = 'HMO';
            localStorage.removeItem(this._storageNames.sede);
        } else {
            this._values.sede = value;
            localStorage.setItem(this._storageNames.sede, value);
        }
    }

    get lastUserLogged(): string { return this._values.lastUserLogged; }
    set lastUserLogged(value: string) {
        if (!value || value == "") {
            this._values.lastUserLogged = '';
            localStorage.removeItem(this._storageNames.lastUserLogged);
        } else {
            this._values.lastUserLogged = value;
            localStorage.setItem(this._storageNames.lastUserLogged, value);
        }
    }

    get showSedeField(): boolean { return this._values.showSedeField; }
    set showSedeField(value: boolean) {
        if (!value) {
            this._values.showSedeField = false;
            localStorage.removeItem(this._storageNames.showSedeField);
        } else {
            this._values.showSedeField = false;
            localStorage.setItem(this._storageNames.showSedeField, value.toString());
        }
    }

    get userToken(): string { 
        //this._values.userToken =  localStorage.getItem(this._storageNames.userToken); 
        return this._values.userToken; 
    }
    set userToken(value: string) {
        if (!value || value == "") {
            this._values.userToken = null;
            localStorage.removeItem(this._storageNames.userToken);
        } else {
            this._values.userToken = value;
            localStorage.setItem(this._storageNames.userToken, value);
        }
    }

    get user(): any { return this._values.user; }
    set user(value: any) {
        if (!value || value == "") {
            this._values.user = null;
            localStorage.removeItem(this._storageNames.user);
        } else {
            this._values.user = value;
            localStorage.setItem(this._storageNames.user, JSON.stringify(value));
        }
    }

    get commonConfig(): any { return this._values.commonConfig; }
    set commonConfig(value: any) {
        if (!value || value == "") {
            this._values.commonConfig = null;
        } else {
            this._values.commonConfig = value;
        }
    }

    get clientPictures(): any {
        if(!this._values.clientPictures) {
            this._values.clientPictures= [];
            this.clientPictures = [];
        }
        return this._values.clientPictures; 
    }
    set clientPictures(value: any) {
        if (!value) {
            this._values.clientPictures = [];
            localStorage.removeItem(this._storageNames.clientPictures);
        } else {
            this._values.clientPictures = value;
            localStorage.setItem(this._storageNames.clientPictures, JSON.stringify(value));
        }
    }


    init() {
        for(let i in this._storageNames) {
            let value = localStorage.getItem( this._storageNames[i]);
            try{
                this._values[i] = JSON.parse(value);

            } catch(e) {
                this._values[i] = value;
            }
        }
    }


}


// WEBPACK FOOTER //
// C:/projects/angular/DineroAgil/src/app/providers/local/user-data.ts